import { configureStore, combineReducers } from '@reduxjs/toolkit';
import authReducer from '../views/auth/reducer';
import recepcaoReducer from '../views/recepcao/recepcaoReducer';
import orcamentoReducer from '../views/orcamento/orcamentoReducer';
import administracaoReducer from '../views/administracao/administracaoReducer';

import storage from 'redux-persist/lib/storage';
import { persistReducer, persistStore } from 'redux-persist';
import {
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';

// ✅ persiste só o que precisa do auth (pra não salvar password/isLoading etc.)
const authPersistConfig = {
  key: 'auth',
  version: 1,
  storage,
  whitelist: ['accessToken', 'refreshToken', 'userType', 'codigoVoluntario'],
};

const rootReducer = combineReducers({
  auth: persistReducer(authPersistConfig, authReducer),
  recepcao: recepcaoReducer,
  orcamento: orcamentoReducer,
  administracao: administracaoReducer,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
